export const BaseStazzleContact = {
  phone: '+49 521 / 8988023',
  mail: 'kontakt@stazzle.de',
  website: 'https://stazzle.de/',
};
